import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';
import { SharedLocType } from '../../shared.locs';

const dpRoot = 'System|Localization|Dialog';

export type LocalizationFormLocs = 'CMSystemLocalizationDialogEditSectionTitle';

export const localizationFormLocs: LocDefs<LocalizationFormLocs> = {
	CMSystemLocalizationDialogEditSectionTitle: {
		defaultValue: 'Edit',
		displayPath: `${dpRoot}|Edit`,
		description: 'Title for the edit section of the HTML editor.',
		displayType: 'Title',
		portal: 'All',
	},
};

export const LOC_KEYS = MapLocKeys<LocalizationFormLocs>(localizationFormLocs);
export type FormLocType = LocMap<LocalizationFormLocs> & SharedLocType;
